<template>
  <!-- 选择类目 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">类目信息</div>
    </div>
    <div class="information_content" style="margin-bottom: 20px">
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          平台分类
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input class="width67" v-model="formData.categoryName" maxlength="20" disabled></el-input>
            <el-button v-if="(!isChakan && system == 5)" style="margin-left: 10px" type="primary"
              @click="openCategoryDialog">
              选择类目
            </el-button>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          标题
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" autosize class="custom-border-purple width67" v-model="formData.itemName"
              show-word-limit :maxlength="200"></el-input>
            <el-button v-if="(!isChakan && system == 5)" style="margin-left: 10px" type="primary"
              @click="inputItemName">
              查询商品类型
            </el-button>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          商品亮点
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" autosize class="custom-border-purple width67" v-model="formData.titleDifferentiation"
              show-word-limit :maxlength="125"></el-input>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          商品类型
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-select class="width67" v-model="formData.shopId" placeholder="请选择商品类型" @change="shopTypeChange" filterable
              ref="selectRef">
              <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
            <el-button v-if="(!isChakan && system == 5)" style="margin-left: 10px" type="primary"
              @click="sInputItemName">
              自主查询商品类型
            </el-button>
          </div>
        </div>
      </div>
      <div style="color: red;margin-left: 150px;">
        温馨提示: 切换商品类型后产品属性将会变更
      </div>
    </div>
    <!-- 内层dialog 开始 -->
    <el-dialog width="1000px" title="选择目录" :visible.sync="innerVisible" append-to-body top="4vh">
      <el-tabs type="border-card">
        <el-tab-pane label="常用分类">
          <div>您有以最近使用分类</div>
          <div class="keyword-list">
            <div v-if="commonClassify.length">
              <template v-for="item in commonClassify">
                <div class="list" :key="item.id">
                  <el-link type="primary" @click="classifyDone(item)">{{ item.name }}</el-link>
                </div>
              </template>
            </div>
            <div class="no-data" v-else>暂无数据</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="所有分类">
          <div class="selectNodeValue">
            {{ innerForm.selectNodeValue }}
          </div>
          <el-button class="mB-20" type="primary" @click="classifyDone({})" :disabled="!innerForm.isLastChildNode">
            确定
          </el-button>
          <el-input class="mB-20" v-model="innerForm.productKeyword" placeholder="输入产品关键字"
            @input="productKeywordInput"></el-input>
          <!-- 级联菜单 -->
          <el-cascader-panel class="custom-cascader" :props="classifyProps" @expand-change="cascaderChange"
            :key="areaName" @change="cascaderChange($event, true)"
            v-show="!innerForm.productKeyword"></el-cascader-panel>
          <!-- 关键字获取的列表 -->
          <div class="keyword-list" v-show="innerForm.productKeyword">
            <div v-if="keywordList.length">
              <template v-for="item in keywordList">
                <div class="list" :key="item.id">
                  <el-link type="primary" @click="classifyDone(item)"
                    v-html="`${item.fullNodeNameChinese} - ${item.fullNodeName}`">
                    <!-- {{ `${item.fullNodeNameChinese} - ${item.fullNodeName}` }}-->
                  </el-link>
                </div>
              </template>
            </div>
            <div class="no-data" v-else>暂无数据</div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
let commonClassifyData = {}
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import leimuSelect from "../uploadProduct.vue";
export default {
  components: { leimuSelect },
  data() {
    return {
      name: "",
      sellerId: "",
      shopList: [],
      // 类目
      innerVisible: false,
      topShuxingArr: [],
      areaName: null,
      innerForm: {
        selectNodeValue: '',
        selectLastNodeId: '',
        productKeyword: '',
        isLastChildNode: false,
        itemType: '',
        nodeId: ''
      },
      keywordList: [],
      commonClassify: [],
      classifyData: {},
      formData: {
        categoryName: "", // 分类名称
        categoryId: "", // 分类id
        itemName: '', //标题
        titleDifferentiation: '', //商品亮点
        shopId: ''
      },
    };
  },
  props: {
    publishInfo: {
      type: Object,
      default: () => ({})
    },
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    classifyProps() {
      return {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          const { level, data } = node
          let customValue = 0
          if (data) customValue = data.customValue
          let areaName = this.areaName
          if (areaName === 'GB') areaName = 'GB'
          let nodeArr = []
          let nodes = []
          if (level === 0) {
            nodeArr = await this.getClassifyParentList(areaName)
          } else {
            nodeArr = await this.getClassifyNextList(customValue)
          }
          if (nodeArr.length) {
            nodes = nodeArr.map((item) => ({
              label: `${item.nodeNameChinese}-${item.nodeName}`,
              value: item,
              customValue: item.id,
              leaf: !item.isHaveChild,
            }))
          }
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(nodes)
        },
      }
    },
  },
  watch: {
    areaName: {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.innerForm.productKeyword = ''
          // 获取当前国家下常用分类
          commonClassifyData =
            JSON.parse(localStorage.getItem('commonClassify')) || {}
          this.commonClassify =
            commonClassifyData[this.areaName] || []
        }
      },
      immediate: true,
    },
  },
  mounted() {

  },
  methods: {
    getData() {
      // 返回所有当前 data
      return { ...this.$data };
    },
    resetData() {
      // 用 Object.assign 替换 this 上的数据为初始状态
      Object.assign(this.$data, this.$options.data.call(this));
    },
    // 商品类型发生变化
    shopTypeChange() {
      this.$nextTick(() => {
        this.$parent.$parent.openDialog(this.publishInfo, 2)
        this.$parent.$parent.shopTypeChange()
      })
    },
    // 保存最近使用分类
    saveLatelyClassify() {
      /**
       * 判断当前选中的这条数据是否有属性值，没有就直接返回
       * 检测本地缓存的数据中有没有当前选中的这条，没有的话就添加进去重新缓存
       */
      if (!Object.keys(this.classifyData).length) return
      const result = this.commonClassify.some(
        (item) => item.id === this.classifyData.id
      )
      if (!result) {
        this.commonClassify.unshift(this.classifyData)
        this.commonClassify.splice(10)
        commonClassifyData[this.areaName] = this.commonClassify
        localStorage.setItem(
          'commonClassify',
          JSON.stringify(commonClassifyData)
        )
      }
    },
    cascaderChange(event, isLast = false) {
      const lastIndex = event.length - 1
      const handlerNodeValue = event.map(
        (item) => `${item.nodeNameChinese}-${item.nodeName}`
      )
      this.innerForm.selectNodeValue = handlerNodeValue.join(' / ')
      this.innerForm.isLastChildNode = false
      this.innerForm.itemType = event[lastIndex].itemType || ''
      this.innerForm.nodeId = event[lastIndex].nodeId || ''
      if (isLast) {
        this.innerForm.isLastChildNode = true
        this.innerForm.selectLastNodeId = event[lastIndex].id
      }
    },
    // 获取一级分类
    getClassifyParentList(country) {
      const API = Baseurl + 'amazonCategory/selectAmazonCategoryList'
      const paramsData = { country }
      return new Promise((resolve, reject) => {
        ajaxPost(API, paramsData)
          .then((res) => {
            const { code, data } = res.data
            if (code === 200) {
              // console.log(data);
              resolve(data)
            } else {
              reject([])
              this.$message.error(message)
            }
          })
          .catch((e) => {
            reject([])
            this.$message.error('获取分类失败')
          })
      })
    },
    // 获取子分类
    getClassifyNextList(id) {
      const API = Baseurl + 'amazonCategory/selectAmazonCategoryByPid'
      const paramsData = { id }
      return new Promise((resolve, reject) => {
        ajaxPost(API, paramsData)
          .then((res) => {
            const { code, data } = res.data
            if (code === 200) {
              // console.log(data);
              resolve(data)
            } else {
              this.$message.error(message)
              reject([])
            }
          })
          .catch((e) => {
            this.$message.error('获取分类失败')
            reject([])
          })
      })
    },
    classifyDone(item) {
      let classifyName = ''
      let classifyId = ''
      let itemType = ''
      let nodeId = ''
      if (Object.keys(item).length) {
        classifyName = item.fullNodeNameChinese || item.name || ''
        classifyId = item.id || ''
        itemType = item.itemType || ''
        nodeId = item.nodeId || ''
      } else {
        classifyName = this.innerForm.selectNodeValue
        classifyId = this.innerForm.selectLastNodeId
        itemType = this.innerForm.itemType
        nodeId = this.innerForm.nodeId
      }
      this.classifyData = { name: classifyName, id: classifyId, itemType: itemType, nodeId: nodeId }
      this.formData.categoryName = classifyName
      this.formData.categoryId = classifyId
      this.innerVisible = false
      this.innerForm.selectNodeValue = ''
      this.innerForm.selectLastNodeId = ''
      this.innerForm.itemType = ''
      this.innerForm.nodeId = ''
      this.$parent.$parent.selectPlatformClassification(this.classifyData)
      this.saveLatelyClassify()
    },
    productKeywordInput() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getKeywordNodeList()
      }, 1000)
    },
    inputItemName() {
      this.getShopType(this.publishInfo)
    },
    sInputItemName() {
      this.sGetShopType(this.publishInfo)
    },
    // 根据内容查找子分类
    getKeywordNodeList() {
      if (!this.innerForm.productKeyword) {
        this.keywordList = []
        return
      }
      const API = Baseurl + 'amazonCategory/selectAmazonCategoryByNodeName'
      const paramsData = {
        country: this.areaName,
        nodeName: this.innerForm.productKeyword,
      }
      ajaxPost(API, paramsData)
        .then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.keywordList = data
          } else {
            this.$message.error(message)
          }
        })
        .catch((e) => {
          this.$message.error('查找失败')
        })
    },
    // 获取商品类型
    getShopType(item) {
      this.$parent.$parent.dialogLoding = true
      let paramsData = {
        sellerId: item.sellerId,
        marketplaceId: item.row.marketplaceId,
        itemName: this.formData.itemName
      }
      let API = null;
      API = Baseurl + 'amazonProductType/getSuggestedProductTypes'
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code == 200) {
            this.shopList = res.data.data
            this.$nextTick(() => {
              this.$refs.selectRef.$el.click();  // 模拟点击触发下拉框展开
            });
            this.$parent.$parent.dialogLoding = false
          } else {
            this.$message({
              type: 'error',
              message: res.data.message,
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    sGetShopType(item) {
      this.$parent.$parent.dialogLoding = true
      let paramsData = {
        marketplaceIds: item.row.marketplaceId,
      }
      let API = null;
      API = Baseurl + 'amazonProductType/getProductTypes'
      ajaxPost(API, paramsData)
        .then((res) => {
          if (res.data.code == 200) {
            this.shopList = res.data.data
            this.$nextTick(() => {
              this.$refs.selectRef.$el.click();  // 模拟点击触发下拉框展开
            });
            this.$parent.$parent.dialogLoding = false
          } else {
            this.$message({
              type: 'error',
              message: res.data.message,
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //是否inny自定义开头【不区分大小写】
    isInnyStart(field, list) {
      if (field) {
        const str = list
          ?.find((ele) => ele.value === field)
          ?.label?.toLowerCase();
        return str?.startsWith("inny") || str?.startsWith("inna");
      }
      return false;
    },
    setName(name) {
      this.$refs.leimu.categorySearchText = name;
      this.name = name;
    },
    setSellerId(sellerId) {
      this.$refs.leimu.sellerId = sellerId;
      this.sellerId = sellerId;
    },
    initData() {
      this.formData.categoryName = "";
      this.topShuxingArr = [];
    },
    openCategoryDialog() {
      this.innerVisible = true;
    },
    //打开推荐类目弹窗
    openTuijianDialog() {
      this.$refs.leimu.openDialog("tuijian");
    },
    //点击类目返回的属性
    categoryAttr(list, categoryName, categoryId) {
      this.$emit('setCategoryId', categoryId)
      let arrList = list;
      this.formData.categoryName = categoryName;
      this.formData.categoryId = categoryId;
      arrList.forEach((item) => {
        //存放限定值  {multipleChoices:false} false单选,true多选
        if (item.restrictions) {
          item.restrictions = JSON.parse(item.restrictions);
        }
        if (item.options) {
          item.options = JSON.parse(item.options);
        }
        if (item.type == "string") {
          item.fieldValue = "";
        } else if (item.type == "integer") {
          item.fieldValue = undefined;
        } else if (item.type == "float") {
          item.fieldValue = undefined;
        } else if (item.type == "dictionary") {
          //这个是多选
          if (item.restrictions && item.restrictions.multipleChoices) {
            item.fieldValue = [];
          } else {
            item.fieldValue = undefined;
          }
          const filterFlag = item.name === "Marka" || item.name === "Producent" || item.name === "Producent części" || item.name === "Wydawnictwo";
          let selectDropList = item.parameterDictionaryList; //选择的下拉数据
          if (filterFlag) {
            selectDropList =
              (item.dictionary && JSON.parse(item.dictionary)) || [];
          }
          item.parameterDictionaryList = selectDropList.map((itemMap) => {
            return {
              label:
                itemMap.value +
                (itemMap.cnValue ? "(" + itemMap.cnValue + ")" : ""),
              value: filterFlag ? itemMap.id : itemMap.dictionaryId,
              pinjieName: itemMap.value,
              parameterId: item.parameterId,
              values: undefined,
            };
          });
        }
      });
    },

    addToBianti(item, index) {
      this.topShuxingArr.splice(index, 1);
      this.topShuxingArr = [...this.topShuxingArr];
      //父组件添加变体属性
      this.$emit("addToBianti", item);
    },
    //增加下面移除的变体
    addTopAttrList(attrList) {
      this.topShuxingArr = this.topShuxingArr.concat(attrList);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";

.shuxing_box {
  min-height: 100px;
  background: rgb(238, 238, 238);
  border-radius: 10px;
  width: 88%;
  float: left;
  padding: 10px 0;
  font-size: 16px;

  .item_shuxing {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 4px;

    .shuxing_label {
      width: 40%;
      text-align: right;
      padding: 3px 10px;

      .shuxing_label_bitian {
        color: red;
        margin-right: 4px;
      }
    }

    .shuxing_input {
      width: 100%;
    }

    .shuxing_select {
      width: 100%;
    }

    .shuxing_button {
      width: 30px;
      height: 30px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgb(255, 183, 82);
      color: white;
      font-weight: 700;
      font-size: 20px;
      margin-left: 10px;
    }
  }
}

.input_bot_tip {
  display: flex;
  flex-direction: column;
}

.search_box {
  padding: 15px 10px;
  width: calc(100% - 20px);
  background: rgb(238, 238, 238);
  margin-top: 10px;
  display: flex;

  .search_box_item {
    width: 30%;
    margin-right: 20px;

    .leimu_box {
      height: 400px;
      padding: 10px;
      overflow-y: auto;
      background: white;

      .leimu_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 5px 0;
        font-size: 16px;

        .leimu_item_desc {
          width: calc(100% - 20px);
          white-space: nowrap;
          /* 确保文本在一行内显示 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
        }

        .item_leimu_you {
          color: rgb(82, 190, 166);
          margin-top: 3px;
        }
      }

      .select_leimu {
        border: 1px solid rgb(82, 190, 166);
        box-sizing: content-box;
      }

      .leimu_item:hover {
        border: 1px solid rgb(82, 190, 166);
        color: rgb(82, 190, 166);
        box-sizing: content-box;
      }
    }
  }
}

.search_box2 {
  padding: 15px 0px 15px 2px;
  width: calc(100%);
  background: rgb(238, 238, 238);
  margin-top: 10px;
}

.leimu_box2 {
  height: 400px;
  padding: 10px;
  overflow-y: auto;
  background: white;
  width: calc(100% - 20px);

  .leimu_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 7px 0;
    font-size: 14px;

    .leimu_item_desc {
      width: calc(100% - 20px);
      white-space: nowrap;
      /* 确保文本在一行内显示 */
      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
    }

    .item_leimu_you {
      color: rgb(82, 190, 166);
      margin-top: 3px;
    }
  }

  .select_leimu {
    border: 1px solid rgb(82, 190, 166);
    box-sizing: content-box;
  }

  .leimu_item:hover {
    border: 1px solid rgb(82, 190, 166);
    color: rgb(82, 190, 166);
    box-sizing: content-box;
  }
}

.item_img {
  height: 16px;
  width: 16px;
  margin-left: 5px;
  cursor: pointer;
}

.el_tip_box {
  width: 360px;
  font-size: 16px;
  background: rgb(39, 39, 39);
  border-radius: 10px;
  padding: 8px;
  color: whitesmoke;
}

.shuxing_button {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 183, 82);
  color: white;
  font-weight: 700;
  font-size: 20px;
  margin-left: 10px;
}

.selectNodeValue {
  min-height: 30px;
  display: flex;
  align-items: center;
  padding: 10px 0;
}

// 级联面板
/deep/ .el-cascader-panel.custom-cascader {
  overflow: auto;

  .el-cascader-menu__wrap {
    height: 450px;
  }
}

.keyword-list {
  width: 100%;
  height: 430px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;

  .list {
    min-height: 30px;
    display: flex;
    align-items: center;
    padding: 5px 0;
    white-space: nowrap;
  }

  .no-data {
    text-align: center;
    line-height: 40px;
    color: #999;
    user-select: none;
  }
}
</style>